module.exports = __webpack_public_path__ + "school/img/guoxueketang.34874d92.png";